import amplitude from "amplitude-js";
import {
    LOG_EVENT_PROPERTIES_OBJECT_EXPECTED,
    LOG_EVENT_TYPE_STRING_EXPECTED
} from "../shared/analytics/constants";

let hasOptedOut;
export const persistentEventsCache = [];

/**
 * Log an event with eventType and eventProperties
 * @param {string} eventType - name of event
 * @param {object} [eventProperties] - (optional) an object with string keys and values
 * for the event properties
 * @see https://amplitude.zendesk.com/hc/en-us/articles/115002889587-JavaScript-SDK-Reference
 * @example log('search_initiated', {'location': 'landing', 'term': 'apples'});
 */
export const log = (eventType, eventProperties = {}) => {
    if (typeof eventType !== 'string') {
        throw new Error(LOG_EVENT_TYPE_STRING_EXPECTED);
    }

    if (eventProperties && typeof eventProperties !== 'object') {
        throw new Error(LOG_EVENT_PROPERTIES_OBJECT_EXPECTED);
    }

    if (hasOptedOut) {
        persistentEventsCache.push({ eventType, eventProperties });
        return;
    }

    amplitude.getInstance().logEvent(eventType, eventProperties);
};
export const flushPersistentEventsCache = () => {
    if (!persistentEventsCache.length) { return; }

    const amplitudeInstance = amplitude.getInstance();

    persistentEventsCache.forEach((event) => {
        const { eventType, eventProperties } = event;

        amplitudeInstance.logEvent(eventType, eventProperties);
    });

    persistentEventsCache.splice(0, persistentEventsCache.length);
};

/**
 * Set Opt Out
 * @param {boolean} shouldOptOut - wether or not to opt out
 * @see https://amplitude.zendesk.com/hc/en-us/articles/115002889587-JavaScript-SDK-Reference
 * @example optOut(false)
 */
export const amplitudeOptOut = (shouldOptOut) => {
    hasOptedOut = shouldOptOut;
    amplitude.getInstance().setOptOut(shouldOptOut);

    if (!shouldOptOut) {
        flushPersistentEventsCache();
    }
};
export const useAmplitude = ({apiKey, apiDomain, shouldOptOut}) => {
    amplitude.getInstance().init(apiKey, null, {
        includeReferrer: true,
        unsetParamsReferrerOnNewSession: true,
        apiEndpoint: `${apiDomain}`,
        deviceIdFromUrlParam: true,
        optOut: shouldOptOut
    });
    hasOptedOut = shouldOptOut;
};